<div class="content-box_module__333d9 content-box_lg__3v3a-">
    <header _ngcontent-bps-c143="" class="content-box_header__xPnGx clearfix">
        <div _ngcontent-bps-c143="" class="wil-float-left">
            <h4 _ngcontent-bps-c143="" class="content-box_title__1gBHS">
                <span _ngcontent-bps-c143="">Change Password</span>
            </h4>
        </div>
    </header>

    <div class="content-box_body__3tSRB">
        <form (ngSubmit)="onSubmit()" [formGroup]="changePasswordForm">
            <mat-form-field>
                <mat-label>Password</mat-label>
                <input required matInput type="password" formControlName="password" />
            </mat-form-field>
            <mat-form-field>
                <mat-label>New Password</mat-label>
                <input required matInput type="password" formControlName="new_password" />
            </mat-form-field>
            <mat-form-field>
                <mat-label>Confirm Password</mat-label>
                <input required matInput type="password" formControlName="confirm_password" />
            </mat-form-field>

            <button mat-raised-button class="wil-btn wil-btn--primary wil-btn--round wil-btn--lg wil-btn--block"
                color="primary" type="submit" [disabled]="!changePasswordForm.valid">
                Save Changes
            </button>
            <div *ngIf="showError" class="mt-10">
                <p *ngFor="let errorMessage of errorMessage" class="errorMessage">{{ errorMessage }}</p>
            </div>

        </form>
    </div>
</div>